module.exports = __webpack_public_path__ + "img/cat-winking.d6bc3119.gif";